
import { PropTypes } from 'prop-types';
import { DecodeHtml } from '../utils/decodeHtml';
const BenefitsAndServicesForAlumni = ({ ourAlumni }) => {



    const title = ourAlumni?.secondMainTitle
    const description = ourAlumni?.secondMainDescription

    const cards = ourAlumni?.advantagesRow?.items?.map((item) => {
        item = item?.content?.properties
        return {
            title: item?.title,
            points: DecodeHtml({ html: item?.content?.markup })
        }
    })

   
    return (

        <div className="lg:shadow-lg p-2 md:p-12 max-w-7xl 2xl:-translate-y-[10rem] bg-white">
            <div className="flex flex-col gap-4">
                <div className="flex flex-col gap-8 p-6">
                    <h1 className="w-auto  text-slate-900 text-3xl md:text-5xl font-bold ">{title}</h1>
                    <p className="w-auto  text-justify text-sky-950 text-opacity-70 text-base font-normal leading-normal">{description}</p>

                </div>
                <div
                    className="flex items-center justify-center p-4 rounded-lg border lg:border-0 shadow-md hover:shadow-lg transition duration-300 ease-in-out my-5">
                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4  gap-4 ">
                        {
                            cards?.slice(0, 4)?.map((card, index) => (
                                <div
                                    className={`flex flex-col items-center  max-w-[25rem] gap-4 p-4 ${index < 3 && "border-b sm:border-b-0 sm:border-r border-dashed border-gray-300"} `}
                                    key={index}>
                                    <div className="flex flex-col items-center justify-center gap-2">
                                        <h2 className="w-auto  text-slate-900 text-lg text-center font-extrabold ">{card?.title}</h2>
                                        {
                                            card?.points
                                        }
                                        {/* <ul className="flex flex-col items-center justify-center self-center list-disc">
                                            {
                                                card.points.map((point, index) => (
                                                    <li key={index} className="w-auto  text-center text-sky-950 text-opacity-70 text-base font-normal leading-normal">{point}</li>
                                                ))
                                            }

                                        </ul> */}
                                    </div>
                                </div>
                            ))
                        }

                    </div>
                </div>
                {
                    cards?.length > 4 &&
                    <div
                        className="flex items-center justify-center p-4 rounded-lg border lg:border-0 shadow-md hover:shadow-lg transition duration-300 ease-in-out my-5">
                        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4  gap-4 ">
                            {

                                cards?.slice(4, 8)?.map((card, index) => (
                                    <div
                                        className={`flex flex-col items-center  max-w-[25rem] gap-4 p-4 ${index < 3 && "border-b sm:border-b-0 sm:border-r border-dashed border-gray-300"} `}
                                        key={index}>
                                        <div className="flex flex-col items-center justify-center gap-2">
                                            <h2 className="w-auto  text-slate-900 text-lg text-center font-extrabold ">{card?.title}</h2>
                                            {
                                                card?.points
                                            }
                                        </div>
                                    </div>
                                ))
                            }

                        </div>
                    </div>
                }
            </div>
        </div>


    )
}
BenefitsAndServicesForAlumni.propTypes = {
    ourAlumni: PropTypes.any
}
export default BenefitsAndServicesForAlumni